import { useMutation } from '@tanstack/react-query';
import req from 'utils/req';
import { useAccount } from '~/authentication/store';

type JoinItinerariesType = {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  onJoinItineraries: (itineraries: string[]) => void;
};

function useJoinItineraries({ onSuccess }): JoinItinerariesType {
  const { account } = useAccount();
  const mutation = useMutation(
    (itineraries: string[]) => {
      return req(
        `${URL_API_HOST}/api/v1/portfolio/inventory/itinerary/host/${account.id}/join`,
      ).put(itineraries);
    },
    {
      onSuccess,
    },
  );

  return {
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    onJoinItineraries: mutation.mutate,
  };
}

export default useJoinItineraries;
